import React from 'react';
import PropTypes from 'prop-types';
import GeofZdMSateliteDetailsEdit from '../../geofert/zonaDeManejo/satelite/detailsEdit/DetailsEdit';
import GeofZdMCondEletDetailsEdit from '../../geofert/zonaDeManejo/condutividadeEletrica/detailsEdit/DetailsEdit';
import GeofZdMVantDetailsEdit from '../../geofert/zonaDeManejo/vant/detailsEdit/DetailsEdit';
import GeofGridDetailsFields from '../../geofert/grid/detailsFields/DetailsFields';
import PosVendasAssistenciaTecnicaFields from '../../posVendas/assistenciaTecnica/detailsFields/DetailsFields';
import PosVendasLocacaoPilotoFields from '../../posVendas/locacaoPiloto/detailsFields/DetailsFields';
import PosVendasMontagemEquipamentoFields from '../../posVendas/montagemEquipamento/detailsFields/DetailsFields';
import './ServiceRequestFields.scss';

const ServiceRequestFields = (props): JSX.Element | null => {
  const {
    serviceName, serviceTypeName, serviceSubTypeName,
    serviceIdCode, serviceTypeIdCode, serviceSubTypeIdCode,
    formInstance, initialValuesObject,
    allRequestParams, edit, detail,
  } = props;

  const renderGeofertZonaDeManejoSateliteFields = (): JSX.Element => {
    return (
      <GeofZdMSateliteDetailsEdit
        formInstance={formInstance}
        initialValuesObject={initialValuesObject}
        edit={edit}
        detail={detail}
      />
    );
  };

  const renderGeofertZDMVantFields = (): JSX.Element => {
    return (
      <GeofZdMVantDetailsEdit
        formInstance={formInstance}
        initialValuesObject={initialValuesObject}
        allRequestParams={allRequestParams}
        edit={edit}
        detail={detail}
      />
    );
  };

  const renderGeofertZonaDeManejoCondEletFields = (): JSX.Element => {
    return (
      <GeofZdMCondEletDetailsEdit
        formInstance={formInstance}
        initialValuesObject={initialValuesObject}
        edit={edit}
        detail={detail}
      />
    );
  };

  const renderGeofertGridFields = (): JSX.Element => {
    return (
      <GeofGridDetailsFields
        formInstance={formInstance}
        initialValuesObject={initialValuesObject}
        mode="EDIT"
        edit={edit}
        detail={detail}
      />
    );
  };

  const renderPosVendasAssistenciaTecnicaFields = (): JSX.Element => {
    return (
      <PosVendasAssistenciaTecnicaFields
        formInstance={formInstance}
        initialValuesObject={initialValuesObject}
        mode="EDIT"
        edit={edit}
        detail={detail}
      />
    );
  };

  const renderPosVendasLocacaoPilotoFields = (): JSX.Element => {
    return (
      <PosVendasLocacaoPilotoFields
        formInstance={formInstance}
        initialValuesObject={initialValuesObject}
        mode="EDIT"
        edit={edit}
        detail={detail}
      />
    );
  };

  const renderPosVendasMontagemEquipamentoFields = (): JSX.Element => {
    return (
      <PosVendasMontagemEquipamentoFields
        formInstance={formInstance}
        initialValuesObject={initialValuesObject}
        mode="EDIT"
        edit={edit}
        detail={detail}
      />
    );
  };

  const renderFields = (): JSX.Element | null => {
    switch (true) {
      case (serviceIdCode === 'GEOFERT' && serviceTypeIdCode === 'GEOFERT-GRID'):
      case (serviceName?.toUpperCase() === 'GEOFERT' && serviceTypeName?.toUpperCase() === 'GRID'):
        return renderGeofertGridFields();

      case (serviceIdCode === 'GEOFERT' && serviceTypeIdCode === 'GEOFERT-ZONA_MANEJO' && serviceSubTypeIdCode === 'GEOFERT-ZONA_MANEJO-SATELITE'):
      case (serviceName?.toUpperCase() === 'GEOFERT' && serviceTypeName?.toUpperCase() === 'ZONA DE MANEJO' && serviceSubTypeName?.toUpperCase() === 'SATÉLITE'):
        return renderGeofertZonaDeManejoSateliteFields();

      case (serviceIdCode === 'GEOFERT' && serviceTypeIdCode === 'GEOFERT-ZONA_MANEJO' && serviceSubTypeIdCode === 'GEOFERT-ZONA_MANEJO-CONDUTIVIDADE_ELETRICA'):
      case (serviceName?.toUpperCase() === 'GEOFERT' && serviceTypeName?.toUpperCase() === 'ZONA DE MANEJO' && serviceSubTypeName?.toUpperCase() === 'CONDUTIVIDADE ELÉTRICA'):
        return renderGeofertZonaDeManejoCondEletFields();

      case (serviceIdCode === 'GEOFERT' && serviceTypeIdCode === 'GEOFERT-ZONA_MANEJO' && serviceSubTypeIdCode === 'GEOFERT-ZONA_MANEJO-VANT'):
      case (serviceName?.toUpperCase() === 'GEOFERT' && serviceTypeName?.toUpperCase() === 'ZONA DE MANEJO' && serviceSubTypeName?.toUpperCase() === 'VANT'):
        return renderGeofertZDMVantFields();

      case (serviceName?.toUpperCase() === 'PÓS-VENDAS' && serviceTypeName?.toUpperCase() === 'ASSISTÊNCIA TÉCNICA'):
        return renderPosVendasAssistenciaTecnicaFields();

      case (serviceName?.toUpperCase() === 'PÓS-VENDAS' && serviceTypeName?.toUpperCase() === 'LOCAÇÃO DE PILOTO'):
        return renderPosVendasLocacaoPilotoFields();

      case (serviceName?.toUpperCase() === 'PÓS-VENDAS' && serviceTypeName?.toUpperCase() === 'MONTAGEM DE EQUIPAMENTO'):
        return renderPosVendasMontagemEquipamentoFields();

      default:
        return null;
    }
  };

  return renderFields();
};

ServiceRequestFields.propTypes = {
  serviceName: PropTypes.string,
  serviceIdCode: PropTypes.string,
  serviceTypeName: PropTypes.string,
  serviceTypeIdCode: PropTypes.string,
  serviceSubTypeName: PropTypes.string,
  serviceSubTypeIdCode: PropTypes.string,
  edit: PropTypes.bool,
  detail: PropTypes.bool,

  initialValuesObject: PropTypes.shape({}),

  formInstance: PropTypes.shape({
    getFieldValue: PropTypes.func.isRequired,
  }).isRequired,

  labelClassName: PropTypes.string,
  allRequestParams: PropTypes.shape({}).isRequired,
};

ServiceRequestFields.defaultProps = {
  detail: false,
};

export default ServiceRequestFields;
